import { LazyModule, createLazyComponent, type LazyComponent } from 'owa-bundling';
import type * as lazyIndex from './lazyIndex';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "CopilotSearchAnswer" */ './lazyIndex'),
    { name: 'CopilotSearchAnswer' }
);

// Lazy component for rendering in search results
export const LazyCopilotSearchAnswer: LazyComponent<{}, unknown, void> = createLazyComponent(
    lazyModule,
    (m: typeof lazyIndex) => m.CopilotSearchAnswer
);

// Lazy container that handles search trigger logic
export const LazyCopilotSearchAnswerContainer: LazyComponent<unknown, void> = createLazyComponent(
    lazyModule,
    (m: typeof lazyIndex) => m.CopilotSearchAnswerContainer
);

// Re-export selectors for checking state
export { getCopilotSearchAnswer, getIsLoading } from './selectors/selectors';

// Re-export types
export type { ChatAnswer, ChatErrorType } from './types';
